import { z } from 'zod';
import { isoDate } from '@overseer/contracts';
import { today } from '@/lib/time';
import { monthStart } from './figures';

/**
 * The sales screens' URL state — gastronomy's and catering's: the day, the period and the outlet.
 *
 * In the URL so a link to "the restaurant in August" opens on August. Every key
 * has a default as well as a `.catch()`: the default keeps the key optional on
 * the way in, so the nav can link to a screen without naming a date, and the
 * catch turns a hand-edited `?date=wombat` into today rather than an error.
 */

const dateOrToday = isoDate.catch(() => today()).default(() => today());

/** An outlet code; undefined for all outlets, or on Dziś for the first. */
const outletCode = z.string().min(1).max(32).optional().catch(undefined);

export const gastronomyDaySearchSchema = z.object({
  date: dateOrToday,
  outlet: outletCode,
});
export type GastronomyDaySearch = z.infer<typeof gastronomyDaySearchSchema>;

const periodFields = {
  from: isoDate.catch(() => monthStart(today())).default(() => monthStart(today())),
  to: dateOrToday,
};

export const gastronomyPeriodSearchSchema = z.object({
  ...periodFields,
  outlet: outletCode,
});
export type GastronomyPeriodSearch = z.infer<typeof gastronomyPeriodSearchSchema>;

export const gastronomyControlsSearchSchema = z.object(periodFields);
export type GastronomyControlsSearch = z.infer<typeof gastronomyControlsSearchSchema>;
